import type { HTMLAttributes } from 'react';

import { cn, Image } from '@zoomit/primitives';
import type { CoverImageType } from '@zoomit/web-kit';

import { useOrigin } from '../../providers/OriginProvider';

type StorySize = 'lg' | 'md' | 'sm';

type StoryCircleProps = {
  cover: CoverImageType;
  size?: StorySize;
};

type Props = StoryCircleProps & HTMLAttributes<HTMLDivElement>;

const VideoCircle = (props: Props) => {
  const { cover, size = 'lg', ...rest } = props;

  const { baseMediaUrl } = useOrigin();

  return (
    <div
      className={cn(
        'inline-block cursor-pointer',
        size === 'lg' ? 'h-[88px] w-[88px]' : size === 'md' ? 'h-[56px] w-[56px]' : 'h-[48px] w-[48px]',
        rest.className,
      )}
      {...rest}
    >
      <div
        className={cn(
          'h-full w-full rounded-full p-0.5',
          'bg-[linear-gradient(237deg,rgb(201,19,185)0%,rgb(249,55,63)50%,rgb(254,205,0)100%)]',
        )}
      >
        <div className={'bg-background1 relative h-full w-full rounded-full bg-cover'}>
          <Image
            src={`${baseMediaUrl}/${cover.fileName}-${cover.id}`}
            alt={cover.alt}
            fill
            blurDataURL={cover.preview}
            style={{ objectFit: 'cover', borderRadius: 'inherit', padding: '3px' }}
            sizes="88px"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoCircle;
